// export const listFreemailAuthCountries = [
//   'ch', // SWITZERLAND
//   'fr', // FRANCE
//   'be', // BELGIUM
//   'lu', // LUXEMBOURG
//   'de', // GERMANY
//   'it', // ITALY
//   'us', // UNITED STATES
//   'es', // SPAIN
//   'gb', // UNITED KINGDOM
//   'pf', // FRENCH POLYNESIA
//   'nc', // NEW CALEDONIA
//   'ca', // CANADA
//   'at', // AUSTRIA
//   'nl', // NETHERLANDS
//   'gf', // FRENCH GUIANA
//   'mc', // MONACO
//   'sn', // SENEGAL
//   'ee', // ESTONIA
//   'pt', // PORTUGAL
//   'ma', // MOROCCO
//   'ae', // UNITED ARAB EMIRATES
//   'pl', // POLAND
//   'au', // AUSTRALIA
//   'se', // SWEDEN
//   'gr', // GREECE
//   'ci', // "COTE D'IVOIRE"
//   'li', // LIECHTENSTEIN
//   're', // ILE DE LA REUNION
//   'mx', // MEXICO
//   'ro', // ROMANIA
//   'dk', // DENMARK
//   'th', // THAILAND
//   'no', // NORWAY
//   'dz', // ALGERIA
//   'hk', // HONG KONG
//   'mg', // MADAGASCAR
//   'cg', // CONGO
//   'cr', // COSTA RICA
//   'ru', // RUSSIAN FEDERATION
//   'mt', // MALTA
//   'cz', // CZECH REPUBLIC
//   'ar', // ARGENTINA
//   'br', // BRAZIL
//   'co', // COLOMBIA
//   'tr', // TURKEY
//   'ad', // ANDORRA
//   'sg', // SINGAPORE
//   'bg', // BULGARIA
//   'mm', // MYANMAR
//   'pa', // PANAMA
//   'cl', // CHILE
//   'bf', // BURKINA FASO
//   'cm', // CAMEROON
//   'il', // ISRAEL
//   'kh', // CAMBODIA
//   'lb', // LEBANON
//   'lv', // LATVIA
//   'mr', // MAURITANIA
//   'cd', // CONGO, DR
//   'sk', // SLOVAKIA (Slovak Republic)
//   'vn', // VIET NAM
//   'lt', // LITHUANIA
//   'jp', // JAPAN
//   'pe', // PERU
//   'my', // MALAYSIA
//   'wf', // WALLIS AND FUTUNA ISLANDS
//   'ie', // IRELAND
//   'gp', // GUADELOUPE
//   'as', // AMERICAN SAMOA
//   'bj', // BENIN
//   'mu', // MAURITIUS
//   'ao', // ANGOLA
//   'id', // INDONESIA
//   'bd', // BANGLADESH
//   'md', // MOLDOVA, REPUBLIC OF
//   'cy', // CYPRUS
//   'al', // ALBANIA
//   'gi', // GIBRALTAR
//   'fi', // FINLAND
//   'rw', // RWANDA
//   'ga', // GABON
//   'hr', // CROATIA (local name: Hrvatska)
//   'rs', // SERBIA
//   'is', // ICELAND
//   'tg', // TOGO
//   'mk', // MACEDONIA, REPUBLIC OF
//   'ht', // HAITI
//   'tn', // TUNISIA
//   'im', // ISLE OF MAN
//   'pm', // ST. PIERRE AND MIQUELON
//   'do', // DOMINICAN REPUBLIC
//   'ba', // BOSNIA AND HERZEGOVINA
//   'ml', // MALI
//   'km', // COMOROS
// ];

export const listMyKsuiteAuthorizedCountries = [
  'ch', // switzerland
  'fr', // france
  'be', // belgium
  'lu', // luxembourg
  'de', // germany
  'it', // italy
  'at', // austria
  'es', // spain
  'mc', // monaco
  'mq', // martinique
  'yt', // mayotte
  'gf', // french guiana
  're', // reunion
  'bl', // saint barthélemy
  'tf', // french southern territories
  'pm', // saint pierre and miquelon
  'gp', // guadeloupe
  'mf', // saint martin
  'wf', // wallis and futuna
  'pf', // french polynesia
  'nc', // new caledonia
  'pt', // portugal
  'au', // australia,
  'ca', // canada
  'dk', // danemark
  'fi', // finland
  'gb', // united kingdom
  'gr', // greece
  'ie', // ireland
  'is', // iceland
  'jp', // japan
  'kr', // south korea
  'nl', // netherlands
  'no', // norway
  'nz', // new zealand
  'se', // sweden
  'tr', // turkey
  'us', // united states
  'si', // slovenia
  'pl', // poland
  'cz', // czech republic
  'sk', // slovakia (slovak republic)
  'mx', // mexico
  'lv', // latvia
  'lt', // lithuania
  'il', // israel
  'hu', // hungary,
  'ee', // estonia
  'cr', // costa rica
  'co', // colombia
  'cl', // chile
];
